import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { MapPin, Phone, Mail, Clock, Facebook, Twitter, Instagram, Linkedin } from 'lucide-react';
import logo from "../assets/logopng.png";

const Footer = () => {
  const quickLinks = [
    { path: '/', label: 'Home' },
    { path: '/about', label: 'About Us' },
    { path: '/services', label: 'Services' },
    { path: '/consultants', label: 'Consultants' },
    { path: '/infrastructure', label: 'Infrastructure' },
    { path: '/training', label: 'Insurance' },
    { path: '/gallery', label: 'Gallery' },
    { path: '/contact', label: 'Contact' },
    { path: '/admin', label: 'Admin' },
  ];

  const services = [
    '24/7 Emergency Care',
    'ICU Services',
    'Laboratory',
    '24X7 Medical Shop',
    'Surgical Services',
    'Eye Care',
  ];

  return (
    <footer className="bg-gradient-to-br from-gray-900 via-slate-800 to-gray-900 text-white">
      {/* Main Footer Content */}
      <div className="container mx-auto px-4 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* About Section */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5 }}
          >
           <img src={logo} className='h-32 w-40' />
            <p className="text-gray-300 text-sm leading-relaxed mb-6">
              Providing quality healthcare facilities for middle and lower-class people at affordable prices since 2015.
            </p>
            <div className="flex gap-3">
              <a
                href="https://www.facebook.com/ashokahospital.hubli.56?rdid=TBgmIfaZVFV3Q0BH&share_url=https%3A%2F%2Fwww.facebook.com%2Fshare%2F1AQkJdMMMQ%2F#"
                target='blank'
                className="w-10 h-10 bg-white/10 hover:bg-sky-500 rounded-full flex items-center justify-center transition-all hover:scale-110"
              >
                <Facebook className="w-5 h-5" />
              </a>
              {/* <a
                href="#"
                className="w-10 h-10 bg-white/10 hover:bg-sky-500 rounded-full flex items-center justify-center transition-all hover:scale-110"
              >
                <Twitter className="w-5 h-5" />
              </a> */}
              <a
                href="https://www.instagram.com/ashoka_hospital__hubli/?igsh=MThvMGw2aHRkNXhhOQ%3D%3D#"
                target='blank'
                className="w-10 h-10 bg-white/10 hover:bg-sky-500 rounded-full flex items-center justify-center transition-all hover:scale-110"
              >
                <Instagram className="w-5 h-5" />
              </a>
              {/* <a
                href="#"
                className="w-10 h-10 bg-white/10 hover:bg-sky-500 rounded-full flex items-center justify-center transition-all hover:scale-110"
              >
                <Linkedin className="w-5 h-5" />
              </a> */}
            </div>
          </motion.div>

          {/* Quick Links */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: 0.1 }}
          >
            <h3 className="text-lg font-semibold mb-6 text-sky-400">Quick Links</h3>
            <ul className="space-y-3">
              {quickLinks.map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="text-gray-300 hover:text-sky-400 transition-colors text-sm flex items-center gap-2 group"
                  >
                    <span className="w-0 group-hover:w-2 h-0.5 bg-sky-400 transition-all"></span>
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </motion.div>

          {/* Services */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: 0.2 }}
          >
            <h3 className="text-lg font-semibold mb-6 text-sky-400">Our Services</h3>
            <ul className="space-y-3">
              {services.map((service) => (
                <li key={service} className="text-gray-300 text-sm flex items-center gap-2">
                  <div className="w-1.5 h-1.5 bg-sky-400 rounded-full"></div>
                  {service}
                </li>
              ))}
            </ul>
          </motion.div>

          {/* Contact Info */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: 0.3 }}
          >
            <h3 className="text-lg font-semibold mb-6 text-sky-400">Contact Us</h3>
            <ul className="space-y-4">
              <li className="flex items-start gap-3 text-sm text-gray-300">
                <MapPin className="w-5 h-5 text-sky-400 flex-shrink-0 mt-0.5" />
                <span>Behind Amrut Theatre, Vidyanagar, Hubli-580021</span>
              </li>
              <li className="flex items-center gap-3 text-sm text-gray-300">
                <Phone className="w-5 h-5 text-sky-400 flex-shrink-0" />
                <span>0836-2373778/2373779</span>
              </li>
              <li className="flex items-center gap-3 text-sm text-gray-300">
                <Mail className="w-5 h-5 text-sky-400 flex-shrink-0" />
                <span>ashokahospitalhbl@gmail.com</span>
              </li>
              <li className="flex items-start gap-3 text-sm text-gray-300">
                <Clock className="w-5 h-5 text-sky-400 flex-shrink-0 mt-0.5" />
                <div>
                  <p>Monday-Saturday: 8:00 AM - 9:00 PM</p>
                  {/* <p>Sun: 9:00 AM - 12:00 PM</p> */}
                  <p className="text-sky-400 font-medium mt-1">24/7 Emergency</p>
                </div>
              </li>
            </ul>
          </motion.div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-gray-700">
        <div className="container mx-auto px-4 py-6">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-sm text-gray-400">
              © 2026 Ashoka Hospital. All rights reserved.
            </p>
            <div className="flex gap-6 text-sm text-orange-400">
             <a href="http://x7ittechnologies.com" target='blank' className="hover:text-sky-400 transition-colors">
              Developed By X7 IT Technologies
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;